import React from 'react';
import {
  Modal,
  Stack,
  Text,
  IconButton,
} from '@fluentui/react';

interface ActivityInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ActivityInfoModal: React.FC<ActivityInfoModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onDismiss={onClose}
      isBlocking={false}
      styles={{
        main: {
          width: 600,
          maxWidth: '90%',
          padding: 24,
          borderRadius: 8,
          maxHeight: '85vh',
          overflowY: 'auto',
        },
      }}
    >
      <Stack tokens={{ childrenGap: 16 }}>
        <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
          <Text variant="xLarge" styles={{ root: { fontWeight: 600, color: '#0078d4' } }}>
            Статус активности пользователей
          </Text>
          <IconButton
            iconProps={{ iconName: 'Cancel' }}
            title="Закрыть"
            onClick={onClose}
            styles={{ root: { width: 32, height: 32 } }}
          />
        </Stack>

        <Stack tokens={{ childrenGap: 8 }}>
          <Text variant="large" styles={{ root: { fontWeight: 600 } }}>
            Как работает анализ
          </Text>
          <Text>
            Система анализирует историю входов пользователя за последние 8 недель и определяет 
            его типичный шаблон поведения. На основе этого каждому пользователю присваивается 
            один из статусов активности. (в начале у большинства пользователей будет статус "спящий", 
            т.к. на сбор статистики нужно около 1,5 - 2 месяцев)
          </Text>
          <Text styles={{ root: { fontSize: 12, color: '#605e5c', fontStyle: 'italic' } }}>
            Статус обновляется автоматически при каждом входе пользователя в систему.
          </Text>
        </Stack>

        <Stack tokens={{ childrenGap: 12 }}>
          <Text variant="large" styles={{ root: { fontWeight: 600 } }}>
            Расшифровка статусов
          </Text>

          <Stack
            styles={{
              root: {
                padding: 12,
                backgroundColor: '#f0f9f0',
                borderRadius: 6,
                border: '1px solid #107c10',
              },
            }}
            tokens={{ childrenGap: 4 }}
          >
            <Text styles={{ root: { fontWeight: 700, color: '#107c10', fontSize: 16 } }}>
              Стандарт
            </Text>
            <Text>
              Пользователь входит 4-5 дней в неделю в будние дни. Это нормальный рабочий график.
            </Text>
          </Stack>

          <Stack
            styles={{
              root: {
                padding: 12,
                backgroundColor: '#f0f6ff',
                borderRadius: 6,
                border: '1px solid #0078d4',
              },
            }}
            tokens={{ childrenGap: 4 }}
          >
            <Text styles={{ root: { fontWeight: 700, color: '#0078d4', fontSize: 16 } }}>
              Периодический
            </Text>
            <Text>
              Пользователь входит 2-3 дня в неделю. Работает, но не каждый день.
            </Text>
          </Stack>

          <Stack
            styles={{
              root: {
                padding: 12,
                backgroundColor: '#f9f9f9',
                borderRadius: 6,
                border: '1px solid #605e5c',
              },
            }}
            tokens={{ childrenGap: 4 }}
          >
            <Text styles={{ root: { fontWeight: 700, color: '#605e5c', fontSize: 16 } }}>
              Спящий
            </Text>
            <Text>
              Пользователь входит 0-1 раз в неделю или не входит вообще. Высокий риск оттока.
            </Text>
          </Stack>

          <Stack
            styles={{
              root: {
                padding: 12,
                backgroundColor: '#fff4e6',
                borderRadius: 6,
                border: '1px solid #d83b01',
              },
            }}
            tokens={{ childrenGap: 4 }}
          >
            <Text styles={{ root: { fontWeight: 700, color: '#d83b01', fontSize: 16 } }}>
              Выходной
            </Text>
            <Text>
              Пользователь входит преимущественно в выходные дни (суббота/воскресенье).
            </Text>
          </Stack>

          <Stack
            styles={{
              root: {
                padding: 12,
                backgroundColor: '#ffe6e6',
                borderRadius: 6,
                border: '1px solid #a4262c',
              },
            }}
            tokens={{ childrenGap: 4 }}
          >
            <Text styles={{ root: { fontWeight: 700, color: '#a4262c', fontSize: 16 } }}>
              Нон-стоп
            </Text>
            <Text>
              Пользователь входит 6-7 дней в неделю, почти каждый день. Очень высокая активность.
            </Text>
          </Stack>

          <Stack
            styles={{
              root: {
                padding: 12,
                backgroundColor: '#faf9f8',
                borderRadius: 6,
                border: '1px solid #a19f9d',
              },
            }}
            tokens={{ childrenGap: 4 }}
          >
            <Text styles={{ root: { fontWeight: 700, color: '#a19f9d', fontSize: 16 } }}>
              Неопределено
            </Text>
            <Text>
              Паттерн входов не подходит ни под одну категорию. Возможно, пользователь только начал работать с системой.
            </Text>
          </Stack>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default ActivityInfoModal;